module.exports = __webpack_public_path__ + "static/scale-model-of-dc-by-foot-historic-georgetown-in-alexandria-virginia-0db950cff0f9a4a407cbc721eb32a6a9.png";